import React from 'react';
import { Link } from 'react-router-dom';

const VerificationSuccess = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 p-10 bg-white rounded-lg shadow-md">
        <div className="text-center">
          <svg
            className="mx-auto h-12 w-12 text-green-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            ></path>
          </svg>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Email Verified!
          </h2>
        </div>
        
        <div className="mt-2 text-center text-md text-gray-600">
          <p>
            Your email has been successfully verified. Your account is now active!
          </p>
          <p className="mt-4">
            You can now log in to your account and start using the Kanban Tracker.
          </p>
        </div>
        
        <div className="mt-6">
          <Link 
            to="/login" 
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-blue hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-blue"
          >
            Go to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VerificationSuccess;